import React from 'react';
import Chip from '@mui/material/Chip';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { IAdminUser } from '../../api/admin';

type ProductFlags = Pick<IAdminUser, 'has_platform_access' | 'mcp_enabled' | 'quant_feed_enabled'>;

/** The three ways a client can use Arb. Flags are read-only in this dashboard. */
const PRODUCTS: { key: keyof ProductFlags; label: string; color: 'primary' | 'info' | 'success' }[] = [
	{ key: 'has_platform_access', label: 'Platform', color: 'primary' },
	{ key: 'mcp_enabled', label: 'MCP', color: 'info' },
	{ key: 'quant_feed_enabled', label: 'Quant Feed', color: 'success' },
];

/** Labels of the products the user has, for quick-filter / export. */
export function enabledProducts(user: ProductFlags): string[] {
	return PRODUCTS.filter((p) => user[p.key]).map((p) => p.label);
}

interface Props {
	user: ProductFlags | undefined;
	emptyText?: string;
}

/** One outlined chip per enabled product, in a single row. */
export default function ProductChips({ user, emptyText = 'none' }: Props) {
	if (!user) return <Skeleton width={160} height={28} />;
	const enabled = PRODUCTS.filter((p) => user[p.key]);
	if (enabled.length === 0) {
		return (
			<Typography variant="body2" color="text.disabled">
				{emptyText}
			</Typography>
		);
	}
	return (
		<Stack direction="row" sx={{ flexWrap: 'wrap', gap: 0.75 }}>
			{enabled.map((p) => (
				<Chip key={p.label} label={p.label} size="small" color={p.color} variant="outlined" />
			))}
		</Stack>
	);
}
